export default __webpack_public_path__ + "static/1268-5f1ad6461ff198d91cee9e6de5b0d119.png";